import get from 'lodash/get'

const storeId = process.env.VUE_APP_DEFAULT_STORE_ID || '8b53353d-3f62-45f0-a7e6-b7a993ea7f68'

let config = {
  storeId: get(window, '__appState.store.id', storeId),
  includes: {
    store: {
      with_cities: 'media,contacts,settings,cities.settings,cities.contacts,cities.schedule,cities.stocks.address,cities.stocks.contacts,cities.stocks.schedule,cities.delivery_zones',
      without_cities: 'media,contacts,settings',
    },
    cities: 'settings,contacts,stocks.address,stocks.contacts,stocks.schedule,delivery_zones',
    // TODO the dimensions include is only used to show weight, which is not applicable for each store.
    // Conditionally remove it?
    productsList: 'variants.remainders,variants.option_values.option,media,categories.seo,seo,features,variants.dimensions,modifiers,modifiers_groups,preselected_modifiers',
    appbarProductsSearch: 'variants.option_values.option,categories.seo,seo',
    productItem: 'variants.remainders,variants.option_values.option,media,categories.seo,seo,features,variants.dimensions,modifiers,modifiers_groups,preselected_modifiers',
    order: 'customer,city,stock,variants.variant.option_values.option,variants.product.media,variants.product.categories,variants.modifiers.modifier,variants.modifiers.modifiers_group,payments_summary,payments,promocode',
    ordersHistoryItem: 'variants,variants.product,variants.variant,variants.variant.option_values,variants.modifiers.modifier,variants.modifiers.modifiers_group,payments,delivery_address,stock,statuses_progress,deliver_at_local',
    orderProduct: 'variants.variant.option_values.option,variants.product.media,variants.product.categories,variants.modifiers.modifier,variants.modifiers.modifiers_group',
    profile: 'customer,media',
    offers: 'media,banners,article',
  },
  services: {
    yandex: {
      key: '051098c0-f6eb-4d8d-bec4-3579c55ab118',
    }
  }
}

config.storagePrefix = `zenky:${config.storeId}:`

export default config
